import type { AnnotationApp } from '@telecom/shared/utils/annotation-tool/annotation-app';
import { AnnotationManager } from '@telecom/shared/utils/annotation-tool/services/annotation-manager';

let _annotationManager: AnnotationManager | null = null;

export function setAnnotationManager(annotationManager: AnnotationManager) {
    _annotationManager = annotationManager;
}

export function getAnnotationManager() {
    return _annotationManager;
}

export const AnnotationEditorBinding = Symbol('AnnotationEditor');

let _editor: AnnotationApp | null = null;

export function setEditor(editor: AnnotationApp) {
    _editor = editor;
}

export function getEditor() {
    return _editor;
}
